function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.33 4.49a.312.312 0 0 1-.22-.531L2.668 2.09a.311.311 0 0 1 .44 0L4.664 3.96a.311.311 0 0 1-.22.531H3.51v5.915c0 .172-.14.311-.312.311h-.622a.311.311 0 0 1-.311-.311V4.49H1.33zM5.69 2.284h1.245c.172 0 .311.14.311.311v.623c0 .172-.14.311-.311.311H5.689a.311.311 0 0 1-.312-.311v-.623c0-.172.14-.311.312-.311zm0 4.98h3.735c.172 0 .311.14.311.312v.622c0 .172-.139.312-.31.312H5.688a.311.311 0 0 1-.312-.312v-.622c0-.172.14-.311.312-.311zm0-2.49h2.49c.172 0 .311.14.311.312v.622c0 .172-.14.311-.311.311h-2.49a.311.311 0 0 1-.312-.31v-.623c0-.172.14-.312.312-.312zm0 4.98h4.98c.172 0 .312.14.312.312v.623c0 .172-.14.311-.312.311H5.69a.311.311 0 0 1-.312-.311v-.623c0-.172.14-.311.312-.311z"
});

function SvgIconSortUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortUp);
export default __webpack_public_path__ + "static/media/icon-sort-up.352fbda2.svg";
export { ForwardRef as ReactComponent };